import '@mzara/flow/dist/index.css'
import '@mzara/flow/dist/main.css'

export * from './MindMapRoutes'
